import { history } from "./history"
import { routeTemplates } from "./routeTemplates"
import { mapValues } from "lodash"
import matchPath from "@cirrus/legacy/app-common/alt/framework/matchPath.es6"

export const navigation = mapValues(routeTemplates, (rt) => {
  return {
    createHref: (...args) => {
      return `#${rt.build(...args)}`
    },
    replace: (...args) => history.replace(rt.build(...args)),
    push: (...args) => history.push(rt.build(...args)),
    match: (pathname, exact = true) => matchPath(pathname, { path: rt.config, exact }),
  }
})
